import React, { Component } from 'react'
import { connect } from 'react-redux'
import DeliveryOrder from '../presentational-components/DeliveryOrder'
import { Button, FormControl, Form } from 'react-bootstrap'

import '../../index.css'


let sizes = []
let sizeValues = []

function setSizeDefaults() {
    sizes.map(size => sizeValues.push({ size: size, amount: 0 }))
}

const SizesControl = ({ showSizes }) => {
    sizeValues = []
    console.log("SizesControl")
    console.log(showSizes)
    if (showSizes[0] != null) {
        sizes = showSizes[0].sizes
        setSizeDefaults()
        console.log("SizesControl", showSizes[0].sizes)
        console.log(showSizes[0].sizes)
        return (
            showSizes[0].sizes.map(entry =>
                <div className="form-inline order-input-form">
                    <div className="controlTitle" className="number-input-title">{(entry.SizeValue)}:</div>
                    <div className="number-input-title">{entry.AmountInStorage != undefined ? "(" + entry.AmountInStorage + ")" : " "}</div>
                    {/*<div className="number-input-title">{(entry.AmountInStorage)}</div>*/}
                    <FormControl className="form number-input" min="0" defaultValue="" id={entry.SizeValue} type="number"
                        onChange={handleChange} size="sm" />
                    
                </div>
            )
        )
    } else {
        return (null)
    }
}

const handleChange = value => {
    let entry = sizeValues.findIndex(x => x.size.SizeValue == value.target.id)
    console.log("SizesControl ENTRY")
    console.log(entry)
    console.log(sizeValues)
    sizeValues[entry].amount = value.target.value
}
export {sizeValues}


const testing = (showSizes) => {
    return showSizes;
}

const mapStateToProps = state => ({
    showSizes: testing(state.showSizes)
})


export default connect(mapStateToProps)(SizesControl)

